import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M16 8h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 8h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 16h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 16h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 12h.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Dice5";
const Dice5 = memo(themed(Icon));
export {
  Dice5
};
//# sourceMappingURL=dice-5.js.map
